import React, {Component} from "react"
import PropTypes from "prop-types"

import Overlay from "../Overlay/Overlay"
import "./Sidebar.css"
import classNames from "classnames"

export default class Sidebar extends Component {
	constructor() {
		super()
		this.state = {
			open: false
		}
	}

	scrollTop = () => {
		let $el = document.querySelector( ".sidebar.left" )
		if ( $el ) $el.scrollTo( 0, 0 )
	}

	componentDidMount() {
		let body = document.getElementsByTagName( "body" )[0]
		const open = () => {
			addClass( body, "sidebar-r" )
			this.setState( {open: true} )
			this.scrollTop()
		}
		const close = () => {
			removeClass( body, "sidebar-r" )
			this.setState( {open: false} )
		}
		const toggle = () => {
			if ( this.state.open ) removeClass( body, "sidebar-r" )
			if ( !this.state.open ) addClass( body, "sidebar-r" )
			this.setState( {open: !this.state.open} )
			this.scrollTop()
		}

		this.props.open.add( open )
		this.props.close.add( close )
		this.props.toggle.add( toggle )

		this.open = open
		this.close = close
		this.toggle = toggle
	}

	componentWillUnmount() {
		this.props.open.remove( this.open )
		this.props.close.remove( this.close )
		this.props.toggle.remove( this.toggle )
	}

	render() {

		let {children, left} = this.props
		let open = !!this.state.open
		return (
			<div>
				<Overlay open={!!this.state.open}
						 onClick={this.props.close.dispatch} />
				<div className={classNames( `sidebar`, {left}, {open} )}>
					<section className="SidebarSection h-100">
						{children}
					</section>
				</div>
			</div>
		)
	}
}

function addClass( element, classString ) {
	element.className = element
		.className
		.split( " " )
		.filter( ( name ) => {
			return name !== classString
		} )
		.concat( classString )
		.join( " " )
}

function removeClass( element, classString ) {
	element.className = element
		.className
		.split( " " )
		.filter( ( name ) => {
			return name !== classString
		} )
		.join( " " )
}

Sidebar.propTypes = {
	open    : PropTypes.object,
	toggle  : PropTypes.object,
	close   : PropTypes.object,
	children: PropTypes.any
}




// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js